class BaseResultResponseDto {
  /** 状态码 */
  code = "";

  /** 返回数据 */
  data = new IPage();

  /** failed */
  failed = false;

  /** 消息 */
  msg = "";

  /** 原数据，测试使用 */
  originData = undefined;

  /** 结果状态是否成功，false:服务器运行错误 */
  success = false;

  /** 返回数据total */
  total = undefined;

  /** traceId */
  traceId = "";
}

class CharSequence {}

class Client {
  /** clientId */
  clientId = "";
}

class ClientDto {
  /** accessTokenValiditySeconds */
  accessTokenValiditySeconds = undefined;

  /** clientCode */
  clientCode = "";

  /** clientSecret */
  clientSecret = "";

  /** grantType */
  grantType = "";

  /** id */
  id = undefined;

  /** redirectUri */
  redirectUri = "";

  /** refreshTokenValiditySeconds */
  refreshTokenValiditySeconds = undefined;

  /** resUrls */
  resUrls = [];

  /** scope */
  scope = [];
}

class Code {
  /** code */
  code = "";
}

class Comparable {}

class DeptManagerResponseDto {
  /** 钉钉部门id(根节点id=1) */
  deptId = undefined;

  /** 部门等级 */
  deptLevel = undefined;

  /** 部门主管Userid(钉钉的Userid,只取钉钉返回值第一条) */
  deptManagerUserid = "";

  /** 钉钉部门父级id */
  deptParentId = undefined;

  /** 钉钉部门父级名称 */
  deptParentName = "";

  /** 部门名称 */
  name = "";

  /** 主管用户编号,为空表示该部门没有领导 */
  supervisorUserCode = "";

  /** 主管用户姓名 */
  supervisorUserName = "";
}

class IAMCommonRequestDto {
  /** 应用ID */
  appId = "";

  /** 加密的内容 */
  content = "";

  /** Unix时间戳(毫秒) */
  timestamp = undefined;
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class LoginCheckRequestDto {
  /** sso重定向地址 */
  redirectUrl = "";

  /** 系统编号 */
  systemNo = "";

  /** 用户编号 */
  userNo = "";
}

class LoginCheckResponseDto {
  /** sso重定向地址 */
  redirectUrl = "";

  /** 系统编号 */
  systemNo = "";

  /** ticket票据 */
  ticket = "";
}

class LoginExchangeDto {
  /** accessToken */
  accessToken = "";

  /** clientCode */
  clientCode = "";

  /** expiresIn */
  expiresIn = undefined;

  /** openId */
  openId = "";

  /** refreshToken */
  refreshToken = "";

  /** scope */
  scope = [];

  /** userCode */
  userCode = "";

  /** userId */
  userId = undefined;

  /** userName */
  userName = "";
}

class LoginRequestDto {
  /** 密码 */
  password = "";

  /** sso重定向地址 */
  redirectUrl = "";

  /** 用户名 */
  userName = "";
}

class LoginResponseDto {
  /** accessToken截止时间，时间戳，毫秒 */
  accessExpiresIn = undefined;

  /** accessToken */
  accessToken = "";

  /** 有效期（秒） */
  expiresIn = undefined;

  /** 刷新token截止时间，时间戳，毫秒 */
  refreshExpiresIn = undefined;

  /** 刷新token */
  refreshToken = "";

  /** st */
  serviceTicket = "";

  /** 过期时间 */
  tokenExpire = "";

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class MainBodyRequestDto {
  /** 编号 */
  bodyNumber = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";
}

class MainBodyResponseDto {
  /** 编号 */
  bodyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class MediaSocialModel {
  /** createBy */
  createBy = "";

  /** createTime */
  createTime = "";

  /** deleted */
  deleted = undefined;

  /** id */
  id = undefined;

  /** lockVersion */
  lockVersion = undefined;

  /** platformUserInfo */
  platformUserInfo = "";

  /** platformUserNo */
  platformUserNo = "";

  /** type */
  type = undefined;

  /** updateBy */
  updateBy = "";

  /** updateTime */
  updateTime = "";

  /** userNo */
  userNo = "";
}

class MediaSocialRequestDto {
  /** id */
  id = undefined;

  /** 第三方平台用户信息，json格式保存 */
  platformUserInfo = "";

  /** 平台用户编号 */
  platformUserNo = "";

  /** 类型，10：wechat，20：qq */
  type = undefined;

  /** 用户编号 */
  userNo = "";
}

class MediaSocialResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 第三方平台用户信息，json格式保存 */
  platformUserInfo = "";

  /** 平台用户编号 */
  platformUserNo = "";

  /** 类型，10：wechat，20：qq */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户编号 */
  userNo = "";
}

class OrganizationLevelRequestDto {
  /** 主体编号 */
  bodyNumber = "";

  /** id */
  id = undefined;

  /** 级别，L1 */
  level = "";

  /** 名称 */
  name = "";
}

class OrganizationLevelResponseDto {
  /** 主体编号 */
  bodyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 级别，L1 */
  level = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OrganizationPostRelationRequestDto {
  /** 是否到岗，0：未到，1：已到 */
  arrived = undefined;

  /** 主体编号 */
  bodyNumber = "";

  /** id */
  id = undefined;

  /** 是否主管，0：不是，1：是 */
  manager = undefined;

  /** 组织架构id */
  organizationId = undefined;

  /** 未入职计划职级等级，JSON格式 */
  planRank = "";

  /** 岗位id */
  postId = undefined;

  /** 岗位名称 */
  postName = "";

  /** 职级id */
  rankId = undefined;

  /** 职级等级，如1，2 */
  rankLevel = undefined;

  /** 职级类型：E，M，P，B */
  rankType = "";

  /** 员工姓名 */
  realName = "";

  /** 岗位类型，10：全职，20：代理，30：兼职 */
  type = undefined;

  /** 用户编号 */
  userNo = "";
}

class OrganizationPostRelationResponseDto {
  /** 是否到岗，0：未到，1：已到 */
  arrived = undefined;

  /** 主体编号 */
  bodyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 是否主管，0：不是，1：是 */
  manager = undefined;

  /** 组织架构id */
  organizationId = undefined;

  /** 未入职计划职级等级，JSON格式 */
  planRank = "";

  /** 岗位id */
  postId = undefined;

  /** 岗位名称 */
  postName = "";

  /** 职级id */
  rankId = undefined;

  /** 职级等级，如1，2 */
  rankLevel = undefined;

  /** 职级类型：E，M，P，B */
  rankType = "";

  /** 员工姓名 */
  realName = "";

  /** 岗位类型，10：全职，20：代理，30：兼职 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户编号 */
  userNo = "";
}

class OrganizationPostRequestDto {
  /** 主体编号 */
  bodyNumber = "";

  /** 职责说明 */
  duty = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";
}

class OrganizationPostResponseDto {
  /** 主体编号 */
  bodyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 职责说明 */
  duty = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OrganizationRankRequestDto {
  /** 主体编号 */
  bodyNumber = "";

  /** id */
  id = undefined;

  /** 等级，如1，2 */
  level = undefined;

  /** 全称 */
  name = "";

  /** 职级类型：E，M，P，B */
  type = "";
}

class OrganizationRankResponseDto {
  /** 主体编号 */
  bodyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 等级，如1，2 */
  level = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 全称 */
  name = "";

  /** 职级类型：E，M，P，B */
  type = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OrganizationRequestDto {
  /** 主体编号 */
  bodyNumber = "";

  /** id */
  id = undefined;

  /** 是否隐藏，0：否，1：是 */
  ifHidden = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 组织名称 */
  name = "";

  /** 已到岗人数 */
  numberOfArrived = undefined;

  /** 下属人数 */
  numberOfSubordinates = undefined;

  /** 级别id */
  organizationLevelId = undefined;

  /** 组织架构岗位明细 */
  organizationPostRelation = [];

  /** 上级id，0表示顶级 */
  parentId = undefined;

  /** 全路径id，格式为1,2 */
  path = "";

  /** 主管用户编号 */
  supervisorUserCode = "";

  /** 主管用户姓名 */
  supervisorUserName = "";
}

class OrganizationResponseDto {
  /** 主体编号 */
  bodyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 钉钉部门id(根节点id=1) */
  deptId = undefined;

  /** 部门等级 */
  deptLevel = undefined;

  /** 部门主管Userid(钉钉的Userid,只取钉钉返回值第一条) */
  deptManagerUserid = "";

  /** 部门排序 */
  deptOrder = undefined;

  /** 钉钉部门父级id */
  deptParentId = undefined;

  /** 钉钉部门父级名称 */
  deptParentName = "";

  /** id */
  id = undefined;

  /** 是否隐藏，0：否，1：是 */
  ifHidden = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 组织名称 */
  name = "";

  /** 已到岗人数 */
  numberOfArrived = undefined;

  /** 下属人数 */
  numberOfSubordinates = undefined;

  /** 级别id */
  organizationLevelId = undefined;

  /** 组织架构岗位明细 */
  organizationPostRelation = [];

  /** 上级id，0表示顶级 */
  parentId = undefined;

  /** 全路径id，格式为1,2 */
  path = "";

  /** 主管用户编号 */
  supervisorUserCode = "";

  /** 主管用户姓名 */
  supervisorUserName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OrganizationStaffModel {
  /** bankName */
  bankName = "";

  /** birthday */
  birthday = "";

  /** bodyNumber */
  bodyNumber = "";

  /** cityCode */
  cityCode = "";

  /** cityName */
  cityName = "";

  /** createBy */
  createBy = "";

  /** createTime */
  createTime = "";

  /** deleted */
  deleted = undefined;

  /** departureTime */
  departureTime = "";

  /** deptId */
  deptId = undefined;

  /** deptLevel */
  deptLevel = undefined;

  /** deptName */
  deptName = "";

  /** electronicSigned */
  electronicSigned = "";

  /** email */
  email = "";

  /** entryTime */
  entryTime = "";

  /** id */
  id = undefined;

  /** jobNo */
  jobNo = "";

  /** lockVersion */
  lockVersion = undefined;

  /** manager */
  manager = undefined;

  /** openBankName */
  openBankName = "";

  /** organizationDeptId */
  organizationDeptId = undefined;

  /** organizationId */
  organizationId = undefined;

  /** paymentAccount */
  paymentAccount = "";

  /** phone */
  phone = "";

  /** postId */
  postId = undefined;

  /** provinceCode */
  provinceCode = "";

  /** provinceName */
  provinceName = "";

  /** rankId */
  rankId = undefined;

  /** realName */
  realName = "";

  /** sex */
  sex = undefined;

  /** status */
  status = undefined;

  /** updateBy */
  updateBy = "";

  /** updateTime */
  updateTime = "";

  /** userNo */
  userNo = "";

  /** userid */
  userid = "";
}

class OrganizationStaffPushRequestDto {
  /** 工号列表 */
  jobNos = [];
}

class OrganizationStaffRelationResponseDto {
  /** 主体名称 */
  bodyName = "";

  /** 主体编号 */
  bodyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 离职时间 */
  departureTime = "";

  /** 电子签名图片链接 */
  electronicSigned = "";

  /** 企业邮箱 */
  email = "";

  /** 入职时间 */
  entryTime = "";

  /** id */
  id = undefined;

  /** 工号 */
  jobNo = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 是否主管，0：不是，1：是 */
  manager = undefined;

  /** 一级组织架构id，部门id */
  organizationDeptId = undefined;

  /** 组织架构id */
  organizationId = undefined;

  /** 手机号码 */
  phone = "";

  /** 岗位id */
  postId = undefined;

  /** 职级id */
  rankId = undefined;

  /** 姓名 */
  realName = "";

  /** 性别，0：男，1：女 */
  sex = undefined;

  /** 状态，10：在职，20：离职 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户编号 */
  userNo = "";
}

class OrganizationStaffRequestDto {
  /** 收款银行 */
  bankName = "";

  /** 生日 */
  birthday = "";

  /** 主体编号 */
  bodyNumber = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 离职时间 */
  departureTime = "";

  /** deptId */
  deptId = undefined;

  /** 部门名称 */
  deptName = "";

  /** 电子签名图片链接 */
  electronicSigned = "";

  /** 企业邮箱 */
  email = "";

  /** 入职时间 */
  entryTime = "";

  /** id */
  id = undefined;

  /** 工号 */
  jobNo = "";

  /** 是否主管，0：不是，1：是 */
  manager = undefined;

  /** 开户银行 */
  openBankName = "";

  /** 组织架构id */
  organizationId = undefined;

  /** 收款账户 */
  paymentAccount = "";

  /** 手机号码 */
  phone = "";

  /** 岗位id */
  postId = undefined;

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";

  /** 职级id */
  rankId = undefined;

  /** 姓名 */
  realName = "";

  /** 性别，0：男，1：女 */
  sex = undefined;

  /** 状态，10：在职，20：离职 */
  status = undefined;

  /** 用户编号 */
  userNo = "";
}

class OrganizationStaffRequestParamsDto {
  /** 主体编号，等于 */
  bodyNumber = "";

  /** 主体编号，全模糊匹配包含 */
  bodyNumberLike = "";

  /** 主体编号，不等于 */
  bodyNumberNe = "";

  /** 主体编号，全模糊匹配不包含 */
  bodyNumberNotLike = "";

  /** 创建人，等于 */
  createBy = "";

  /** 创建人，全模糊匹配包含 */
  createByLike = "";

  /** 创建人，不等于 */
  createByNe = "";

  /** 创建人，全模糊匹配不包含 */
  createByNotLike = "";

  /** 创建时间，等于 */
  createTime = "";

  /** 创建时间，大于等于 */
  createTimeGe = "";

  /** 创建时间，小于等于 */
  createTimeLe = "";

  /** 创建时间，不等于 */
  createTimeNe = "";

  /** 离职时间，等于 */
  departureTime = "";

  /** 离职时间，大于等于 */
  departureTimeGe = "";

  /** 离职时间，小于等于 */
  departureTimeLe = "";

  /** 离职时间，不等于 */
  departureTimeNe = "";

  /** 钉钉部门编号，等于 */
  deptId = undefined;

  /** 部门等级，等于 */
  deptLevel = undefined;

  /** 钉钉部门名称，等于 */
  deptName = "";

  /** 企业邮箱，等于 */
  email = "";

  /** 企业邮箱，全模糊匹配包含 */
  emailLike = "";

  /** 企业邮箱，不等于 */
  emailNe = "";

  /** 企业邮箱，全模糊匹配不包含 */
  emailNotLike = "";

  /** 入职时间，等于 */
  entryTime = "";

  /** 入职时间，大于等于 */
  entryTimeGe = "";

  /** 入职时间，小于等于 */
  entryTimeLe = "";

  /** 入职时间，不等于 */
  entryTimeNe = "";

  /** id，等于 */
  id = undefined;

  /** id，不等于 */
  idNe = undefined;

  /** 工号，等于 */
  jobNo = "";

  /** 工号，全模糊匹配包含 */
  jobNoLike = "";

  /** 工号，不等于 */
  jobNoNe = "";

  /** 工号，全模糊匹配不包含 */
  jobNoNotLike = "";

  /** 乐观锁，等于 */
  lockVersion = undefined;

  /** 乐观锁，不等于 */
  lockVersionNe = undefined;

  /** 是否主管，0：不是，1：是，等于 */
  manager = undefined;

  /** 是否主管，0：不是，1：是，不等于 */
  managerNe = undefined;

  /** 排序，如id|desc,name|asc */
  orderBy = "";

  /** 一级组织架构id，部门id，等于 */
  organizationDeptId = undefined;

  /** 组织架构id，等于 */
  organizationId = undefined;

  /** 组织架构id，不等于 */
  organizationIdNe = undefined;

  /** 手机号码，等于 */
  phone = "";

  /** 手机号码，全模糊匹配包含 */
  phoneLike = "";

  /** 手机号码，不等于 */
  phoneNe = "";

  /** 手机号码，全模糊匹配不包含 */
  phoneNotLike = "";

  /** 岗位id，等于 */
  postId = undefined;

  /** 岗位id，不等于 */
  postIdNe = undefined;

  /** 职级id，等于 */
  rankId = undefined;

  /** 职级id，不等于 */
  rankIdNe = undefined;

  /** 姓名，等于 */
  realName = "";

  /** 姓名，全模糊匹配包含 */
  realNameLike = "";

  /** 姓名，不等于 */
  realNameNe = "";

  /** 姓名，全模糊匹配不包含 */
  realNameNotLike = "";

  /** 性别，0：男，1：女，等于 */
  sex = undefined;

  /** 性别，0：男，1：女，不等于 */
  sexNe = undefined;

  /** 状态，10：在职，20：离职，等于 */
  status = undefined;

  /** 状态，10：在职，20：离职，不等于 */
  statusNe = undefined;

  /** 更新人，等于 */
  updateBy = "";

  /** 更新人，全模糊匹配包含 */
  updateByLike = "";

  /** 更新人，不等于 */
  updateByNe = "";

  /** 更新人，全模糊匹配不包含 */
  updateByNotLike = "";

  /** 更新时间，等于 */
  updateTime = "";

  /** 更新时间，大于等于 */
  updateTimeGe = "";

  /** 更新时间，小于等于 */
  updateTimeLe = "";

  /** 更新时间，不等于 */
  updateTimeNe = "";

  /** 用户编号，包含列表 */
  userIn = [];

  /** 用户编号，等于 */
  userNo = "";

  /** 用户编号，全模糊匹配包含 */
  userNoLike = "";

  /** 用户编号，不等于 */
  userNoNe = "";

  /** 用户编号，全模糊匹配不包含 */
  userNoNotLike = "";

  /** 用户表更新时间，大于等于 */
  userUpdateTimeGe = "";

  /** 钉钉用户编号，等于 */
  userid = "";
}

class OrganizationStaffResponseDto {
  /** 收款银行 */
  bankName = "";

  /** 生日 */
  birthday = "";

  /** 主体编号 */
  bodyNumber = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 离职时间 */
  departureTime = "";

  /** 钉钉部门编号 */
  deptId = undefined;

  /** 部门等级 */
  deptLevel = undefined;

  /** 员工本部门及所有上级部门 */
  deptList = [];

  /** 部门名称 */
  deptName = "";

  /** 电子签名图片链接 */
  electronicSigned = "";

  /** 企业邮箱 */
  email = "";

  /** 入职时间 */
  entryTime = "";

  /** id */
  id = undefined;

  /** 工号 */
  jobNo = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 是否主管，0：不是，1：是 */
  manager = undefined;

  /** 开户银行 */
  openBankName = "";

  /** 一级组织架构id，部门id */
  organizationDeptId = undefined;

  /** 组织架构id */
  organizationId = undefined;

  /** 组织架构名称 */
  organizationName = "";

  /** 收款账户 */
  paymentAccount = "";

  /** 手机号码 */
  phone = "";

  /** 岗位id */
  postId = undefined;

  /** 岗位名称 */
  postName = "";

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";

  /** 职级id */
  rankId = undefined;

  /** 职级名称 */
  rankName = "";

  /** 姓名 */
  realName = "";

  /** 性别，0：男，1：女 */
  sex = undefined;

  /** 状态，10：在职，20：离职 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户编号 */
  userNo = "";

  /** 钉钉用户编号 */
  userid = "";
}

class OrganizationTreeResponseDto {
  /** 主体编号 */
  bodyNumber = "";

  /** 钉钉部门id(根节点id=1) */
  deptId = undefined;

  /** 部门等级 */
  deptLevel = undefined;

  /** 部门主管Userid(钉钉的Userid,只取钉钉返回值第一条) */
  deptManagerUserid = "";

  /** 部门排序 */
  deptOrder = undefined;

  /** 钉钉部门父级id */
  deptParentId = undefined;

  /** 钉钉部门父级名称 */
  deptParentName = "";

  /** id */
  id = undefined;

  /** 是否隐藏，0：否，1：是 */
  ifHidden = undefined;

  /** 组织名称 */
  name = "";

  /** 已到岗人数 */
  numberOfArrived = undefined;

  /** 下属人数 */
  numberOfSubordinates = undefined;

  /** 下级组织架构信息 */
  organizationChildList = [];

  /** 级别id */
  organizationLevelId = undefined;

  /** 组织架构岗位明细 */
  organizationPostRelation = [];

  /** 上级id，0表示顶级 */
  parentId = undefined;

  /** 全路径id，格式为1,2 */
  path = "";

  /** 主管用户编号 */
  supervisorUserCode = "";

  /** 主管用户姓名 */
  supervisorUserName = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new ClientDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class RoleMenuListResponseDto {
  /** 菜单代码 */
  code = "";

  /** id */
  id = undefined;

  /** 菜单名称 */
  name = "";

  /** 菜单资源 */
  roleMenuResourceDtoList = [];
}

class RoleMenuResourceRequestDto {
  /** 菜单编号 */
  menuCodeList = [];

  /** 资源id */
  resourceIdList = [];
}

class RoleMenuResourceResponseDto {
  /** 菜单编号 */
  menuCode = "";

  /** 资源备注 */
  remark = "";

  /** 资源路径 */
  resUrl = "";

  /** 资源Id */
  resourceId = undefined;

  /** 资源名称 */
  resourceName = "";

  /** 路由别名 */
  routeAlias = "";

  /** 类型 1:按钮 5:资源 10:资源按钮 */
  type = undefined;
}

class StaffAccountResponseDto {
  /** 用户头像 */
  avatar = "";

  /** 主体编号 */
  bodyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 企业邮箱 */
  email = "";

  /** 工号 */
  jobNo = "";

  /** 部门id */
  organizationDeptId = undefined;

  /** 部门名称 */
  organizationDeptName = "";

  /** 手机号码 */
  phone = "";

  /** 岗位id */
  postId = undefined;

  /** 岗位名称 */
  postName = "";

  /** 姓名 */
  realName = "";

  /** 性别，0：男，1：女 */
  sex = undefined;

  /** 状态，10：在职，20：离职 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SupplierLoginRequestDto {
  /** 密码 */
  password = "";

  /** sso重定向地址 */
  redirectUrl = "";

  /** 用户名 */
  username = "";
}

class SupplierLoginResponseDto {
  /** accessToken */
  accessToken = "";

  /** 客户端编号 */
  clientCode = "";

  /** 过期时间 */
  expiresIn = undefined;

  /** sso重定向地址 */
  redirectUrl = "";

  /** refreshToken */
  refreshToken = "";

  /** serviceTicket */
  serviceTicket = "";

  /** 用户编号 */
  userCode = "";

  /** 用户id */
  userId = undefined;

  /** 用户名 */
  username = "";
}

class SysDataDetailRequestDto {
  /** 是否可授权 0:仅查看、1:查看与授权 */
  authorized = undefined;

  /** 数据权限编码 */
  dataCode = "";
}

class SysDataResponseDto {
  /** 是否可授权 0:仅查看、1:查看与授权 */
  authorized = undefined;

  /** 数据权限编码 */
  dataCode = "";

  /** 数据权限类型 1:产品线、2:BU类型、3:登录菜单首页 */
  dataType = undefined;
}

class SysMenuRequestDto {
  /** 所属系统资源路径 */
  appEntry = "";

  /** 所属系统 */
  appName = "";

  /** 菜单编码 */
  code = "";

  /** 功能描述 */
  description = "";

  /** 是否启用，0：否，1：是 */
  enable = undefined;

  /** id */
  id = undefined;

  /** 是否在导航栏显示，0：否，1：是 */
  ifHidden = undefined;

  /** 菜单名称 */
  name = "";

  /** 父菜单编码 */
  parentCode = "";

  /** 菜单url */
  resUrl = "";

  /** 路由别名 */
  routeAlias = "";

  /** 排序 */
  sort = undefined;
}

class SysMenuResourceRequestDto {
  /** id */
  id = undefined;

  /** 菜单编码 */
  menuCode = "";

  /** 资源名称 */
  name = "";

  /** 描述 */
  remark = "";

  /** url */
  resUrl = "";

  /** 排序 */
  sort = undefined;

  /** 类型 1:按钮 5:资源 10:资源按钮 */
  type = undefined;
}

class SysMenuResourceResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 菜单编码 */
  menuCode = "";

  /** 资源名称 */
  name = "";

  /** 描述 */
  remark = "";

  /** url */
  resUrl = "";

  /** 排序 */
  sort = undefined;

  /** 类型 1:按钮 5:资源 10:资源按钮 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SysMenuResponseDto {
  /** 所属系统资源路径 */
  appEntry = "";

  /** 所属系统 */
  appName = "";

  /** 子菜单 */
  children = [];

  /** 菜单编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 功能描述 */
  description = "";

  /** 是否启用，0：否，1：是 */
  enable = undefined;

  /** id */
  id = undefined;

  /** 是否在导航栏显示，0：否，1：是 */
  ifHidden = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 菜单名称 */
  name = "";

  /** 父菜单编码 */
  parentCode = "";

  /** 菜单url */
  resUrl = "";

  /** 菜单资源 */
  roleMenuResourceDtoList = [];

  /** 路由别名 */
  routeAlias = "";

  /** 排序 */
  sort = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SysNumStepRequestDto {
  /** 开始数字,默认1 */
  beginNum = undefined;

  /** 循环周期 10:天循环 20:月循环 30:年循环 40:永久 */
  cycle = undefined;

  /** 日期格式,支持date的格式 */
  dateStr = "";

  /** 超出异常处理 0:截取 1:抛出异常 */
  exceedFlag = undefined;

  /** id */
  id = undefined;

  /** 标签，在系统下唯一 */
  label = "";

  /** 长度，算上前缀、后缀 */
  lengthSize = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 编号名 */
  numStepName = "";

  /** 前缀 */
  prefix = "";

  /** 进制 */
  radix = undefined;

  /** 备注 */
  remark = "";

  /** 补充字段 */
  spadChar = "";

  /** 补充位置 1:left 2:right */
  spadPosition = undefined;

  /** 步进 */
  stepNum = undefined;

  /** 后缀 */
  suffix = "";

  /** 所属系统，默认UC */
  systemNo = "";

  /** 作用的字段,用作后期数据恢复使用 */
  tableField = "";

  /** 作用的表 */
  tableName = "";
}

class SysNumStepResponseDto {
  /** 开始数字,默认1 */
  beginNum = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 循环周期 10:天循环 20:月循环 30:年循环 40:永久 */
  cycle = undefined;

  /** 日期格式,支持date的格式 */
  dateStr = "";

  /** 超出异常处理 0:截取 1:抛出异常 */
  exceedFlag = undefined;

  /** id */
  id = undefined;

  /** 标签，在系统下唯一 */
  label = "";

  /** 长度，算上前缀、后缀 */
  lengthSize = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 编号名 */
  numStepName = "";

  /** 前缀 */
  prefix = "";

  /** 进制 */
  radix = undefined;

  /** 备注 */
  remark = "";

  /** 补充字段 */
  spadChar = "";

  /** 补充位置 1:left 2:right */
  spadPosition = undefined;

  /** 步进 */
  stepNum = undefined;

  /** 后缀 */
  suffix = "";

  /** 所属系统，默认UC */
  systemNo = "";

  /** 作用的字段,用作后期数据恢复使用 */
  tableField = "";

  /** 作用的表 */
  tableName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SysPropertiesRequestDto {
  /** id */
  id = undefined;

  /** key */
  key = "";

  /** 名称 */
  name = "";

  /** 备注 */
  remark = "";

  /** value */
  value = "";
}

class SysPropertiesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** key */
  key = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 备注 */
  remark = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** value */
  value = "";
}

class SysRoleAndSubordinateResponseDto {
  /** 角色列表 */
  roleList = [];

  /** 下属和当前人编号列表 */
  subordinateCodeList = [];
}

class SysRoleDataRequestDto {
  /** 数据权限类型 1:产品线、2:BU类型、3:登录菜单首页 */
  dataType = undefined;

  /** details */
  details = [];

  /** 角色Code */
  roleCode = "";

  /** 角色ID */
  roleId = undefined;
}

class SysRoleRequestDto {
  /** id */
  id = undefined;

  /** 角色描述 */
  roleDesc = "";

  /** 角色名称 */
  roleName = "";
}

class SysRoleResourceRequestDto {
  /** id */
  id = undefined;

  /** 资源id */
  resourceId = undefined;

  /** 角色id */
  roleId = undefined;
}

class SysRoleResourceResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 资源id */
  resourceId = undefined;

  /** 角色id */
  roleId = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SysRoleResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 角色编码 */
  roleCode = "";

  /** 角色描述 */
  roleDesc = "";

  /** 角色名称 */
  roleName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SysTableauResponseDto {
  /** siteId */
  siteId = "";

  /** token */
  token = "";

  /** userId */
  userId = "";
}

class SysTableauTreeResponseDto {
  /** children */
  children = [];

  /** description */
  description = "";

  /** id */
  id = "";

  /** name */
  name = "";

  /** type */
  type = "";
}

class SysTableauViewResponseDto {
  /** contentUrl */
  contentUrl = "";

  /** createdAt */
  createdAt = "";

  /** id */
  id = "";

  /** name */
  name = "";

  /** updatedAt */
  updatedAt = "";

  /** viewUrlName */
  viewUrlName = "";

  /** workbook */
  workbook = undefined;
}

class SysTableauWorkbookResponseDto {
  /** contentUrl */
  contentUrl = "";

  /** createdAt */
  createdAt = "";

  /** dataAccelerationConfig */
  dataAccelerationConfig = undefined;

  /** defaultViewId */
  defaultViewId = "";

  /** description */
  description = "";

  /** encryptExtracts */
  encryptExtracts = false;

  /** id */
  id = "";

  /** name */
  name = "";

  /** owner */
  owner = undefined;

  /** project */
  project = undefined;

  /** showTabs */
  showTabs = false;

  /** size */
  size = undefined;

  /** updatedAt */
  updatedAt = "";

  /** webpageUrl */
  webpageUrl = "";
}

class SysUserDataRequestDto {
  /** 数据权限类型 1:产品线、2:BU类型、3:登录菜单首页 */
  dataType = undefined;

  /** details */
  details = [];

  /** 用户编号 */
  userNo = "";
}

class SysUserLoginLogRequestDto {
  /** 客户端ip */
  clientIp = "";

  /** 客户端类型，10：电脑，20：手机 */
  clientType = undefined;

  /** id */
  id = undefined;

  /** 操作类型，10:登录，20:登出 */
  operationType = undefined;

  /** 系统编号 */
  systemNo = "";

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SysUserLoginLogResponseDto {
  /** 客户端ip */
  clientIp = "";

  /** 客户端类型，10：电脑，20：手机 */
  clientType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 操作类型，10:登录，20:登出 */
  operationType = undefined;

  /** 系统编号 */
  systemNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SysUserPushRequestDto {
  /** 推送平台 */
  clientList = [];

  /** 用户邮箱 */
  email = "";

  /** 用户密码 */
  password = "";

  /** 用户手机号码 */
  phone = "";

  /** 状态，0：禁用，1：启用 */
  status = undefined;

  /** 类型，10：内部，20：外部 */
  type = undefined;

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SysUserRequestDto {
  /** 用户头像 */
  avatar = "";

  /** 推送平台 */
  clientList = [];

  /** 用户邮箱 */
  email = "";

  /** id */
  id = undefined;

  /** 员工档案信息 */
  organizationStaff = new OrganizationStaffRequestDto();

  /** 用户密码 */
  password = "";

  /** 用户手机号码 */
  phone = "";

  /** 状态，0：禁用，1：启用 */
  status = undefined;

  /** 类型，10：内部，20：外部 */
  type = undefined;

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SysUserResponseDto {
  /** 用户头像 */
  avatar = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 用户邮箱 */
  email = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 员工档案信息 */
  organizationStaff = [];

  /** 用户手机号码 */
  phone = "";

  /** 状态，0：禁用，1：启用 */
  status = undefined;

  /** 类型，10：内部，20：外部 */
  type = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";

  /** 用户角色分组，1：普通用户，2：普通管理员，3：超级管理员 */
  userRoleType = undefined;

  /** 是否绑定微信账号，1：未绑定，2：已绑定 */
  wxBind = undefined;
}

class SysUserRpcRequestDto {
  /** 用户头像 */
  avatar = "";

  /** 用户邮箱 */
  email = "";

  /** 用户手机号码 */
  phone = "";

  /** 状态，0：禁用，1：启用 */
  status = undefined;

  /** 类型，10：内部，20：外部，30：供应商 */
  type = undefined;

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SysUserTableauRequestDto {
  /** tableau账号 */
  tableauNo = "";

  /** tableau密码 */
  tableauPassword = "";

  /** 用户编号 */
  userNo = "";
}

class SysUserTokenRequestDto {
  /** token */
  accessToken = "";

  /** id */
  id = undefined;

  /** 过期时间 */
  tokenExpire = "";

  /** 用户id */
  userId = undefined;

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class SysUserTokenResponseDto {
  /** token */
  accessToken = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 过期时间 */
  tokenExpire = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 用户id */
  userId = undefined;

  /** 用户姓名 */
  userName = "";

  /** 用户编号 */
  userNo = "";
}

class TicketCheckRequestDto {
  /** ticket票据 */
  ticket = "";
}

class UserDto {
  /** clientCode */
  clientCode = "";

  /** clientList */
  clientList = [];

  /** clientType */
  clientType = "ADMIN";

  /** jobNo */
  jobNo = "";

  /** jti */
  jti = "";

  /** password */
  password = "";

  /** userCode */
  userCode = "";

  /** userId */
  userId = undefined;

  /** userName */
  userName = "";
}

class UserPasswordRequestDto {
  /** 用户确认密码 */
  confirmPassword = "";

  /** 用户新密码 */
  newPassword = "";

  /** 用户原密码 */
  originalPassword = "";

  /** 用户编号 */
  userNo = "";
}

class UserRequestDto {
  /** 应用域编号 */
  appDomainCode = "";

  /** 用户编码列表 */
  userCodes = [];
}

class UserResourceDto {
  /** accessToken */
  accessToken = "";

  /** accessTokenValiditySeconds */
  accessTokenValiditySeconds = undefined;

  /** appResources */
  appResources = [];

  /** clientCode */
  clientCode = "";

  /** clientType */
  clientType = "ADMIN";

  /** expiresIn */
  expiresIn = undefined;

  /** jti */
  jti = "";

  /** refreshTokenValiditySeconds */
  refreshTokenValiditySeconds = undefined;

  /** userCode */
  userCode = "";

  /** userName */
  userName = "";

  /** userResources */
  userResources = [];
}

class UserResponseDto {
  /** 应用域 */
  applicationDomain = "";

  /** 手机区号 */
  areaCode = "";

  /** 头像链接 */
  avatar = "";

  /** 生日 */
  birthday = "";

  /** 国家 */
  country = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 用户邮箱 */
  email = "";

  /** 用户名字 */
  firstname = "";

  /** 用户姓氏 */
  lastname = "";

  /** 用户手机号码 */
  phone = "";

  /** 状态，0：禁用，1：启用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 用户编号 */
  userNo = "";

  /** 账号名 */
  username = "";
}

class UserRoleSetBatchRequestDto {
  /** 角色id集合 */
  roleIdList = [];

  /** 用户编号集合 */
  userNoList = [];
}

export const ucenter = {
  BaseResultResponseDto,
  CharSequence,
  Client,
  ClientDto,
  Code,
  Comparable,
  DeptManagerResponseDto,
  IAMCommonRequestDto,
  IPage,
  LoginCheckRequestDto,
  LoginCheckResponseDto,
  LoginExchangeDto,
  LoginRequestDto,
  LoginResponseDto,
  MainBodyRequestDto,
  MainBodyResponseDto,
  MediaSocialModel,
  MediaSocialRequestDto,
  MediaSocialResponseDto,
  OrganizationLevelRequestDto,
  OrganizationLevelResponseDto,
  OrganizationPostRelationRequestDto,
  OrganizationPostRelationResponseDto,
  OrganizationPostRequestDto,
  OrganizationPostResponseDto,
  OrganizationRankRequestDto,
  OrganizationRankResponseDto,
  OrganizationRequestDto,
  OrganizationResponseDto,
  OrganizationStaffModel,
  OrganizationStaffPushRequestDto,
  OrganizationStaffRelationResponseDto,
  OrganizationStaffRequestDto,
  OrganizationStaffRequestParamsDto,
  OrganizationStaffResponseDto,
  OrganizationTreeResponseDto,
  Response,
  ResponseDto,
  RoleMenuListResponseDto,
  RoleMenuResourceRequestDto,
  RoleMenuResourceResponseDto,
  StaffAccountResponseDto,
  SupplierLoginRequestDto,
  SupplierLoginResponseDto,
  SysDataDetailRequestDto,
  SysDataResponseDto,
  SysMenuRequestDto,
  SysMenuResourceRequestDto,
  SysMenuResourceResponseDto,
  SysMenuResponseDto,
  SysNumStepRequestDto,
  SysNumStepResponseDto,
  SysPropertiesRequestDto,
  SysPropertiesResponseDto,
  SysRoleAndSubordinateResponseDto,
  SysRoleDataRequestDto,
  SysRoleRequestDto,
  SysRoleResourceRequestDto,
  SysRoleResourceResponseDto,
  SysRoleResponseDto,
  SysTableauResponseDto,
  SysTableauTreeResponseDto,
  SysTableauViewResponseDto,
  SysTableauWorkbookResponseDto,
  SysUserDataRequestDto,
  SysUserLoginLogRequestDto,
  SysUserLoginLogResponseDto,
  SysUserPushRequestDto,
  SysUserRequestDto,
  SysUserResponseDto,
  SysUserRpcRequestDto,
  SysUserTableauRequestDto,
  SysUserTokenRequestDto,
  SysUserTokenResponseDto,
  TicketCheckRequestDto,
  UserDto,
  UserPasswordRequestDto,
  UserRequestDto,
  UserResourceDto,
  UserResponseDto,
  UserRoleSetBatchRequestDto,
};
